<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardBody>
                    <OtherDeliveryTabLinks />
                    <OtherDeliveryUpsertForm
                        class="mt-4 ml-2 ml-2"
                        :entity.sync="entity"
                        @update="fetch"
                        @success="$router.push(`/other-delivery`)"
                        @deleted="$router.push(`/other-delivery`)"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import OtherDeliveryTabLinks from '@/components/other-delivery/OtherDeliveryTabLinks';
    import OtherDeliveryUpsertForm from '@/components/other-delivery/OtherDeliveryUpsertForm';

    export default {
        name: 'AdsPlaceEdit',

        components: {
            OtherDeliveryTabLinks,
            OtherDeliveryUpsertForm,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/other-delivery/${id}`)).data;
            },
        },
    };
</script>
